import PropTypes from 'prop-types';
import { Badge, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import React from 'react';

export default function OrganizationCard({ org }) {
    const navigate = useNavigate();
    const desc = org.description;

    const location = [org.location_city, org.location_state]
        .filter(Boolean)
        .join(', ');

    return (
        <Card
            className="data-card h-100 border-0 shadow-sm"
            onClick={() => navigate(`/data/organizations/${org.org_id}`)}
            role="button"
            tabIndex={0}
            aria-label={`View details for ${org.org_name}`}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    navigate(`/data/organizations/${org.org_id}`);
                }
            }}
        >
            <Card.Body className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <Card.Title className="h6 text-primary mb-0 me-2">
                        {org.org_name}
                    </Card.Title>
                    {org.org_type && (
                        <Badge bg="info" className="flex-shrink-0">
                            {org.org_type}
                        </Badge>
                    )}
                </div>
                <Card.Text className="text-body-secondary small flex-grow-1 data-card-desc">
                    {desc}
                </Card.Text>
                <div className="d-flex justify-content-between align-items-center mt-auto">
                    {location && (
                        <small className="text-muted">{location}</small>
                    )}
                    <div className="d-flex gap-2">
                        {org.source_count > 0 && (
                            <small className="text-muted">
                                {org.source_count} source
                                {org.source_count !== 1 ? 's' : ''}
                            </small>
                        )}
                        {org.product_count > 0 && (
                            <small className="text-muted">
                                {org.product_count} product
                                {org.product_count !== 1 ? 's' : ''}
                            </small>
                        )}
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

OrganizationCard.propTypes = {
    org: PropTypes.shape({
        org_id: PropTypes.number.isRequired,
        org_name: PropTypes.string.isRequired,
        description: PropTypes.string,
        org_type: PropTypes.string,
        location_city: PropTypes.string,
        location_state: PropTypes.string,
        source_count: PropTypes.number,
        product_count: PropTypes.number,
    }).isRequired,
};
